export const FEEDBACK_TIMINGS = {
  // How long to show selected state before hiding feedback section
  ACTIVE_STATE_DISPLAY_MS: 1000,
  // Loading iterator interval
  LOADING_ITERATOR_INTERVAL_MS: 2000,
  // Clipboard copy success indicator duration
  CLIPBOARD_SUCCESS_MS: 2000,
} as const;
